// Constant is kept in a separate file so that we can modify it in a test
export const ANIMATION_TYPE_SPEED_MS = 100;
export const ANIMATION_CONTAINER_ID = 'cs-suggestions';
